/* istanbul ignore file */
import { BrowserRouter as Router } from 'react-router-dom';
import { Theme } from 'react-daisyui';
import { Helmet, HelmetProvider } from 'react-helmet-async';

import '@/css/App.css';
import usePendo from '@/hooks/usePendo';
import { UserProvider } from '@/context/UserContext';
import { FeatureFlagProvider } from '@/context/FeatureFlagContext';
import { BugReportButton } from './components/BugReport';

import Routes from './Router';

export default function App() {
  const pendo = usePendo();

  return (
    <UserProvider>
      <FeatureFlagProvider>
        <HelmetProvider>
          {pendo.isInstalled() && (
            <Helmet>
              <script>{pendo.script}</script>
            </Helmet>
          )}
          <Theme dataTheme='opstart'>
            <Router>
              <Routes />
            </Router>
            <footer
              // eslint-disable-next-line max-len
              className='fixed bottom-0 left-0 w-full flex justify-end items-center z-50 bg-transparent pointer-events-none pr-8'
              style={{ minHeight: '60px' }}
            >
              <div className='pointer-events-auto mb-2 hover:animate-bounce duration-300'>
                <BugReportButton />
              </div>
            </footer>
          </Theme>
        </HelmetProvider>
      </FeatureFlagProvider>
    </UserProvider>
  );
}
